import React from 'react'

const ItemListing = ({ children }: any) => {
  return <section className="my-24 grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-12">{children}</section>
}

export default ItemListing
